module.exports = __webpack_public_path__ + "static/media/Illuminas.175c1b04.png";